import Tooltip from "bootstrap/js/dist/tooltip";

(function ($) {
  "use strict";

  class Requests {
    constructor(element) {
      this.$element = element;
      this.$menuHeaderCount = this.$element.closest("li").find("#counts-block");
      this.onRequestsPage = $("body").is(".requests.view");

      this.storage = localStorage;
      this.types = ["informationObject"];
      this.initialItems = {
        informationObject: [],
      };
      this.items =
        JSON.parse(this.storage.getItem("requests")) || this.initialItems;
      this.exportTokens =
        JSON.parse(this.storage.getItem("exportTokens")) || [];

      this.init();
    }

    init() {
      // Listeners added to the document to affect elements added dynamically
      $(document).on("click", "button.requests", this.toggle.bind(this));
      $(document).on(
        "click",
        "button#requests-clear, li#node_clearRequests a",
        this.clear.bind(this)
      );
      $(document).on(
        "click",
        ".requests-all, .requests-none",
        this.toggleAll.bind(this)
      );

      this.updateCounts();
      this.bindModal();
      this.bindRequestTooltips();

      if (this.onRequestsPage) {
        this.loadRequestsContent();
      } else {
        this.updateAllButtons();
      }
    }

    loadRequestsContent() {
      var url = new URL(window.location.href);
      var type = url.searchParams.get("type");

      if (!type || !this.types.includes(type)) {
        type = "informationObject";
      }

      // Get requests content, use post instead of get to
      // reduce URL length and simplify cache proxy config.
      $.ajax({
        url: url,
        type: "POST",
        cache: false,
        data: { slugs: this.items[type] },
        context: this,
        success: function (data) {
          // Replace page content
          $("body > #wrapper").replaceWith($(data).filter("#wrapper"));

          // Attach behaviors to new content
          Drupal.attachBehaviors("#wrapper");

          this.bindModal();
          this.bindRequestTooltips();
          this.updateAllButtons();

          if (this.showSubmitConfirmation) {
            this.showSubmitConfirmation = false;
          }
        },
        error: function () {
          this.showAlert(
            this.$element.data("load-alert-message"),
            "alert-danger"
          );
        },
      });
    }

    bindModal() {
      const openButton = document.getElementById("requests-submit");
      const modal = document.getElementById("requests-modal");

      if (!openButton || !modal || modal.dataset.bound === "true") {
        return;
      }

      const closeButton = modal.querySelector(".modal-close");
      const modalForm = document.getElementById("requests-modal-form");

      const closeModal = () => {
        modal.hidden = true;
      };

      openButton.addEventListener("click", () => {
        modal.hidden = false;
      });

      closeButton?.addEventListener("click", closeModal);

      // Close when clicking outside the dialog box.
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && !modal.hidden) {
          closeModal();
        }
      });

      modalForm?.addEventListener("submit", (event) => {
        event.preventDefault();

        this.items.informationObject.forEach((slug) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "slugs[informationObject][]";
          input.value = slug;
          modalForm.appendChild(input);
        });

        fetch(modalForm.action, {
          method: "POST",
          body: new FormData(modalForm),
          credentials: "same-origin",
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Request failed with status ${response.status}`);
            }

            this.items = this.initialItems;
            this.storage.setItem("requests", JSON.stringify(this.items));
            closeModal();
            this.loadRequestsContent();
          })
          .catch((error) => {
            console.error("Error submitting request:", error);
            this.showAlert("Unable to submit your request.", "alert-danger");
          });
      });

      modal.dataset.bound = "true";
    }

    bindRequestTooltips() {
      document.querySelectorAll("button[data-tooltip='true']").forEach((button) => {
        const tooltipTarget = button.disabled ? button.parentElement : button;

        if (!tooltipTarget || tooltipTarget.dataset.tooltipBound === "true") {
          return;
        }

        Tooltip.getOrCreateInstance(tooltipTarget, {
          title: button.dataset.title,
          placement: "top",
        });
        tooltipTarget.dataset.tooltipBound = "true";
      });
    }

    /**
     * Add a new item to the requests (Archival Descriptions only).
     *
     * @param {String} slug The slug of the item to add
     * @param {String} type The type of item the slug is for (e.g., "informationObject"). See
     *    this.types for valid types
     * @returns {boolean} true if the item was added, false otherwise
     */
    addItem(slug, type) {
      this.items = JSON.parse(this.storage.getItem("requests")) || this.initialItems;

      if (!this.items[type]) {
        return false;
      }

      const index = this.items[type].indexOf(slug);

      // Item is already on requests
      if (index !== -1) {
        return false;
      }

      // Enforce limit if configured on the requests element
      const limitRaw = this.$element.data("requests-limit");
      const limit = typeof limitRaw !== 'undefined' ? parseInt(limitRaw, 10) : NaN;
      if (!isNaN(limit) && limit > 0) {
        const total = Object.keys(this.items).reduce((acc, k) => acc + (Array.isArray(this.items[k]) ? this.items[k].length : 0), 0);
        if (total >= limit) {
          // Show configured limit alert (fallback to export alert)
          this.showAlert(this.$element.data("limit-alert-message") || this.$element.data("export-alert-message"), "alert-danger");
          return false;
        }
      }

      this.items[type].push(slug);

      // Check to see if there's a button that should be updated
      const button = document.querySelector(
        `button[data-requests-slug='${slug}'][data-requests-type='${type}']`
      )

      if (null !== button) {
        // Convert button to a jQuery element
        const $button = $(button);
        this.updateButton($button, true);
      }

      this.storage.setItem("requests", JSON.stringify(this.items));
      this.updateCounts();

      return true;
    }

    toggle(event) {
      if (typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      // Load items from local storage in case activity
      // in another tab has changed the content
      this.items =
        JSON.parse(this.storage.getItem("requests")) || this.initialItems;

      var $button = $(event.target).closest("button");
      var type = $button.data("requests-type");
      var slug = $button.data("requests-slug");
      var index = this.items[type].indexOf(slug);

      if (index === -1) {
        // Delegate adding to addItem which enforces limits and updates state
        this.addItem(slug, type);
      } else {
        this.items[type].splice(index, 1);
        this.updateButton($button, false);
        this.storage.setItem("requests", JSON.stringify(this.items));
        this.updateCounts();
      }
    }

    toggleAll(event) {
      event.preventDefault();
      var add = $(event.target).hasClass("requests-all");
      $("button.requests").each((_, button) => {
        var $button = $(button);
        var added = $button.hasClass("active");
        if ((!added && add) || (added && !add)) $button.trigger("click");
      });
    }

    clear(event) {
      event.preventDefault();

      this.showRemoveAlert();

      var $target = $(event.target);
      var type = $target.data("requests-type");

      if (type && this.types.includes(type)) {
        this.items[type] = [];
      } else {
        this.items = this.initialItems;
      }

      this.storage.setItem("requests", JSON.stringify(this.items));

      this.updateCounts();
      this.updateAllButtons();
    }

    updateButton($button, added) {
      var showTooltip = $button.data("tooltip") != undefined;

      // If previous and current status don't match
      if (
        (!$button.hasClass("active") && added) ||
        ($button.hasClass("active") && !added)
      ) {
        // Update button
        var label = $button.data("title");
        var altLabel = $button.data("alt-title");
        $button.data("alt-title", label);
        $button.data("title", altLabel);
        $button.find("span").text(altLabel);
        $button.toggleClass("active");

        // toggle icon between plus/minus
        $button.find("i.fa-plus, i.fa-minus")
          .toggleClass("fa-plus")
          .toggleClass("fa-minus");

        // Remove tooltip
        if (showTooltip) {
          Tooltip.getOrCreateInstance($button).dispose();
        }

        // Show alert when removing
        if (!added) {
          this.showRemoveAlert();
        }
      }

      // Add tooltip
      if (showTooltip) {
        Tooltip.getOrCreateInstance($button, {
          title: $button.data("title"),
          placement: "left",
        });
      }
    }

    updateCounts() {
      var iosCount = this.items["informationObject"].length;
      var totalCount = iosCount;

      // Menu button count
      var $buttonSpan = this.$element.find("> span.requests-count");
      if (!$buttonSpan.length && totalCount > 0) {
        this.$element.append(
          '<span class="requests-count position-absolute top-0 start-0' +
            ' badge rounded-pill bg-primary">' +
            totalCount +
            '<span class="visually-hidden">' +
            this.$element.data("total-count-label") +
            "</span></span>"
        );
      } else if (totalCount > 0) {
        $buttonSpan.text(totalCount);
      } else if ($buttonSpan.length) {
        $buttonSpan.remove();
      }

      // Menu dropdown header count
      var isRTL = $("html").attr("dir") === "rtl";
      var countText = "";
      var infoLabel = this.$menuHeaderCount.attr(
        "data-information-object-label"
      );

      if (isRTL) {
        countText += iosCount + infoLabel + "<br />";

        this.$menuHeaderCount.attr("dir", "ltr").html(countText);
      } else {
        countText += infoLabel + iosCount + "<br />";

        this.$menuHeaderCount.html(countText);
      }
    }

    updateAllButtons() {
      var self = this;

      $("button.requests").each(function () {
        var $button = $(this);
        var type = $button.data("requests-type");
        var slug = $button.data("requests-slug");
        var added = self.items[type].indexOf(slug) !== -1;

        self.updateButton($button, added);
      });
    }

    showAlert(message, type, deleteUrl) {
      if (!type) {
        type = "";
      }

      var $alert = $(
        '<div class="alert ' +
          type +
          ' alert-dismissible fade show" role="alert">'
      ).append(message);
      var closeButton =
        '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="' +
        this.$element.data("alert-close") +
        '"></button>';

      if (deleteUrl) {
        $alert.append('<a href="' + deleteUrl + '">' + closeButton + "</a>");
      } else {
        $alert.append(closeButton);
      }

      $alert.prependTo($("body > #wrapper"));
      window.scrollTo({ top: 0 });

      return $alert;
    }

    showRemoveAlert() {
      // Show remove alert only in requests page if it is not already added
      if (
        this.onRequestsPage &&
        $("body > #wrapper > .alert-requests-remove").length == 0
      ) {
        this.showAlert(
          this.$element.data("delete-alert-message"),
          "alert-danger alert-requests-remove"
        );
      }
    }
  }

  $(() => {
    var $requests = $("#requests-menu");
    if ($requests.length) {
      window.atomRequests = new Requests($requests);
    }
    else {
      window.atomRequests = null;
    }
  });
})(jQuery);
